import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import './index.css';
import {state} from "../../services/state";
import AllUsersPage from "./AllUsersPage";
import AllUsersPageGrade from "./AllUsersPageGrade";
import TotalGames from "./TotalGames";
import TestsResult from "./TestsResult";
import StatPage from './StatPage';

function State() {
    const [stateData, setStateData] = useState(null)
    const grades = [['total', "همه پایه ها", "#001037", "#001037"],['first', "پایه اول", "#FFB053", "#FFE8CC"],["second", "پایه دوم", "#79FF82", "#CCFFCF"],["third", "پایه سوم", "#42B1F2", "#CFEBFC"],["fourth", "پایه چهارم", "#FF79A1", "#FFCCDB"],["fifth", "پایه پنجم", "#FFE609", "#FFFACC"],["sixth", "پایه ششم", "#7C79FF", "#CDCCFF"]];
    const [situation, setSituation] = useState(
        {
            page_name : "total_games",
            denominator : "total",
            numerator : "entered",
            gradeIndex: 0
        });
    const navigate = useNavigate();
    const { slug } = useParams();

    const setGradeIndex = (grade_index) =>{
        setSituation({
            ...situation,
            page_name:"hooshbazi",
            gradeIndex: grade_index
        });
    }

    const setGradeIndexForDars = (grade_index) =>{
        setSituation({
            ...situation,
            page_name:"darsbazi",
            gradeIndex: grade_index
        });
    }

    const changeTotalToEnteredAndBack = (is_it_total = true,page_name="all_user_page") => {
        setSituation({
            ...situation,
            page_name:page_name,
            denominator: is_it_total ? 'total' : "entered",
            numerator: is_it_total ? 'entered' : "active",
        });
    };

    useEffect(() => {
        state({state_name: slug,})
            .then(response => {
                console.log(response)
                if (response.status === 200 && response.data.body !== null) {
                    setStateData(response.data.body)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }, [slug])

    function back_to_previous_page() {
        navigate('/dashboard/');
    }

    return (
        stateData &&
        <div className="flex font-medium font-mediumFA flex-row justify-center items-center h-screen f-screen p-[min(1vw,2vh)] z-[2] relative">
            <div className="flex flex-col w-[min(83vw,166vh)] h-[min(48vw,96vh)]">
                <div className="flex flex-row rounded-[min(0.5vw,1vh)] h-[min(3vw,6vh)] bg-[#001037] text-white overflow-hidden ">
                    <div onClick={back_to_previous_page}
                         className="cursor-pointer text-[min(1vw,2vh)] flex flex-row justify-center items-center w-[20%] h-full">
                        <img className="h-[70%] mr-2" src="https://uploads.zibazi.tv/site/assets/organ/dashboard/back.png" alt="آیکون"/>
                        <h3>بازگشت به نقشه</h3>
                    </div>
                    <div className="flex flex-row text-[min(1.5vw,3vh)] font-bold justify-center items-center w-[60%] h-full">
                        استان {stateData.name}
                    </div>
                    <div className="flex flex-row text-[min(1.4vw,2.8vh)] justify-center items-center w-[20%] h-full">
                        <h3>{stateData["organ_name"]}</h3>
                        <img className="h-[70%] ml-2" src="https://uploads.zibazi.tv/site/assets/organ/dashboard/user.png" alt="آیکون"/>
                    </div>
                </div>
                {situation["page_name"] === "hooshbazi" && <StatPage
                    StatItems={[
                        ["visual_attention", "دقت دیداری"],
                        ["visual_memory", "حافظه تصویری"],
                        ["spatial_perception", "تجسم فضایی"],
                        ["inhibition", "بازداری"],
                        ["auditory_attention","دقت شنیداری"],
                        ["reasoning", "تفکر و استدلال"],
                        ["flexibility","انعطاف‌پذیری"],
                        ["phonological_memory","حافظه کلامی"],
                        ["language", "کلام و زبان"],
                        ["general_knowledge", "دانش عمومی"],
                    ]} category="hoosh" stateData={stateData} situation={situation} setGradeIndex={setGradeIndex} grades={grades}/>}
                {situation["page_name"] === "darsbazi" && <StatPage
                    StatItems={[
                        ["literature","فارسی"],
                        ["math", "ریاضی"],
                        ["science", "علوم"],
                        ["mixed","تلفیقی"],
                    ]} category="dars" stateData={stateData} situation={situation} setGradeIndex={setGradeIndexForDars} grades={grades}/>}
                {situation["page_name"] === "test_result" && <TestsResult stateData={stateData} situation={situation} setGradeIndex={setGradeIndex} grades={grades}/>}
                {situation["page_name"] === "all_user_page" && <AllUsersPage stateData={stateData} situation={situation} changeTotalToEnteredAndBack={changeTotalToEnteredAndBack}/>}
                {situation["page_name"] === "total_games" && <TotalGames stateData={stateData} grades={grades} situation={situation} changeTotalToEnteredAndBack={changeTotalToEnteredAndBack}/>}
                {situation["page_name"] === "all_user_grades" && <AllUsersPageGrade stateData={stateData} situation={situation} grades={grades} changeTotalToEnteredAndBack={changeTotalToEnteredAndBack}/>}

            </div>
            <div
                className="w-[min(15vw,30vh)] ml-[min(1vw,2vh)] h-[min(48vw,96vh)] bg-[#001037] text-white overflow-hidden rounded-[min(0.5vw,1vh)]">

                <div onClick={() => {
                    changeTotalToEnteredAndBack(true, "total_games")
                }}
                     className={`flex flex-row text-[min(1.2vw,2.4vh)] cursor-pointer mt-[min(1.5vw,3vh)] justify-end border-2 border-[#001037] my-[min(1vw,2vh)] hover:border-[#4044ED] items-center rounded-[min(0.5vw,1vh)] w-[90%] mx-[5%] h-[min(3vw,6vh)] bg-[#${situation["page_name"] === "total_games" ? "4044ED" : "001037"}]`}>
                    میزان فعالیت
                    <img className="h-[70%] m-[8%]"
                         src="https://uploads.zibazi.tv/site/assets/organ/states/activity.png" alt="آیکون"/>
                </div>
                {situation["page_name"] === "total_games" && <div onClick={() => {
                    changeTotalToEnteredAndBack(true, "total_games")
                }}
                                                                  className={`flex flex-row text-[min(1vw,2vh)] cursor-pointer justify-end border-2 border-[#001037] font-light text-right my-[min(1vw,2vh)] hover:border-[#4044ED] items-center rounded-[min(0.5vw,1vh)] w-[80%] mx-[10%] h-[min(2.5vw,5vh)] bg-[#${("total" === situation["denominator"] && situation["page_name"] === "total_games") ? "4044ED" : "001037"}]`}>
                    کل فعالیت ها
                    <span
                        className={"bg-white w-[min(0.75vw,1.5vh)] h-[min(0.75vw,1.5vh)] m-[min(1vw,2vh)] rounded-sm"}></span>
                </div>}

                {situation["page_name"] === "total_games" &&
                    <div onClick={() => changeTotalToEnteredAndBack(false, "total_games")}
                         className={`flex flex-row text-[min(1vw,2vh)] cursor-pointer justify-end border-2 border-[#001037] font-light text-right my-[min(1vw,2vh)] hover:border-[#4044ED] items-center rounded-[min(0.5vw,1vh)] w-[80%] mx-[10%] h-[min(2.5vw,5vh)] bg-[#${("total" !== situation["denominator"] && situation["page_name"] === "total_games") ? "4044ED" : "001037"}]`}>
                        جزئیات فعالیت ها
                        <span
                            className={"bg-white w-[min(0.75vw,1.5vh)] h-[min(0.75vw,1.5vh)] m-[min(1vw,2vh)] rounded-sm"}></span>
                    </div>}

                <div onClick={changeTotalToEnteredAndBack}
                     className={`flex flex-row text-[min(1.2vw,2.4vh)] cursor-pointer justify-end border-2 border-[#001037] my-[min(1vw,2vh)] hover:border-[#4044ED] items-center rounded-[min(0.5vw,1vh)] w-[90%] mx-[5%] h-[min(3vw,6vh)] bg-[#${situation["page_name"] === "all_user_page" ? "4044ED" : "001037"}]`}>
                    تمامی کاربران
                    <img className="h-[70%] m-[8%]"
                         src="https://uploads.zibazi.tv/site/assets/organ/states/alluserpage.png" alt="آیکون"/>
                </div>

                {situation["page_name"] === "all_user_page" && <div onClick={changeTotalToEnteredAndBack}
                                                                    className={`flex flex-row text-[min(1vw,2vh)] cursor-pointer justify-end border-2 border-[#001037] font-light text-right my-[min(1vw,2vh)] hover:border-[#4044ED] items-center rounded-[min(0.5vw,1vh)] w-[80%] mx-[10%] h-[min(2.5vw,5vh)] bg-[#${("total" === situation["denominator"] && situation["page_name"] === "all_user_page") ? "4044ED" : "001037"}]`}>
                    کاربران وارده شده
                    <span
                        className={"bg-white w-[min(0.75vw,1.5vh)] h-[min(0.75vw,1.5vh)] m-[min(1vw,2vh)] rounded-sm"}></span>
                </div>}

                {situation["page_name"] === "all_user_page" && <div onClick={() => changeTotalToEnteredAndBack(false)}
                                                                    className={`flex flex-row text-[min(1vw,2vh)] cursor-pointer justify-end border-2 border-[#001037] font-light text-right my-[min(1vw,2vh)] hover:border-[#4044ED] items-center rounded-[min(0.5vw,1vh)] w-[80%] mx-[10%] h-[min(2.5vw,5vh)] bg-[#${("total" !== situation["denominator"] && situation["page_name"] === "all_user_page") ? "4044ED" : "001037"}]`}>
                    کاربران فعال
                    <span
                        className={"bg-white w-[min(0.75vw,1.5vh)] h-[min(0.75vw,1.5vh)] m-[min(1vw,2vh)] rounded-sm"}></span>
                </div>}

                <div onClick={() => changeTotalToEnteredAndBack(true, "all_user_grades")}
                     className={`flex flex-row text-[min(1.2vw,2.4vh)] cursor-pointer justify-end border-2 border-[#001037] my-[min(1vw,2vh)] hover:border-[#4044ED] items-center rounded-[min(0.5vw,1vh)] w-[90%] mx-[5%] h-[min(3vw,6vh)] bg-[#${situation["page_name"] === "all_user_grades" ? "4044ED" : "001037"}]`}>
                    آمار دانش آموزان
                    <img className="h-[50%] m-[4%]"
                         src="https://uploads.zibazi.tv/site/assets/organ/states/all_grades.png" alt="آیکون"/>
                </div>

                {situation["page_name"] === "all_user_grades" &&
                    <div onClick={() => changeTotalToEnteredAndBack(true, "all_user_grades")}
                         className={`flex flex-row text-[min(1vw,2vh)] cursor-pointer justify-end border-2 border-[#001037] font-light text-right my-[min(1vw,2vh)] hover:border-[#4044ED] items-center rounded-[min(0.5vw,1vh)] w-[80%] mx-[10%] h-[min(2.5vw,5vh)] bg-[#${("total" === situation["denominator"] && situation["page_name"] === "all_user_grades") ? "4044ED" : "001037"}]`}>
                        کاربران وارده شده
                        <span
                            className={"bg-white w-[min(0.75vw,1.5vh)] h-[min(0.75vw,1.5vh)] m-[min(1vw,2vh)] rounded-sm"}></span>
                    </div>}

                {situation["page_name"] === "all_user_grades" &&
                    <div onClick={() => changeTotalToEnteredAndBack(false, "all_user_grades")}
                         className={`flex flex-row text-[min(1vw,2vh)] cursor-pointer justify-end border-2 border-[#001037] font-light text-right my-[min(1vw,2vh)] hover:border-[#4044ED] items-center rounded-[min(0.5vw,1vh)] w-[80%] mx-[10%] h-[min(2.5vw,5vh)] bg-[#${("total" !== situation["denominator"] && situation["page_name"] === "all_user_grades") ? "4044ED" : "001037"}]`}>
                        کاربران فعال
                        <span
                            className={"bg-white w-[min(0.75vw,1.5vh)] h-[min(0.75vw,1.5vh)] m-[min(1vw,2vh)] rounded-sm"}></span>
                    </div>}

                <div onClick={() => changeTotalToEnteredAndBack(true, "test_result")}
                     className={`flex flex-row text-[min(1.2vw,2.4vh)] cursor-pointer mt-[min(1.5vw,3vh)] justify-end border-2 border-[#001037] my-[min(1vw,2vh)] hover:border-[#4044ED] items-center rounded-[min(0.5vw,1vh)] w-[90%] mx-[5%] h-[min(3vw,6vh)] bg-[#${situation["page_name"] === "test_result" ? "4044ED" : "001037"}]`}>
                    ماموریت ها
                    <img className="h-[70%] m-[8%]"
                         src="https://uploads.zibazi.tv/site/assets/organ/dashboard/tests.png" alt="آیکون"/>
                </div>

                <div onClick={() => setGradeIndex(0)}
                     className={`flex flex-row text-[min(1.2vw,2.4vh)] cursor-pointer mt-[min(1.5vw,3vh)] justify-end border-2 border-[#001037] my-[min(1vw,2vh)] hover:border-[#4044ED] items-center rounded-[min(0.5vw,1vh)] w-[90%] mx-[5%] h-[min(3vw,6vh)] bg-[#${situation["page_name"] === "hooshbazi" ? "4044ED" : "001037"}]`}>
                    هوش بازی
                    <img className="h-[70%] m-[8%]"
                         src="https://uploads.zibazi.tv/site/assets/organ/states/hooshbazi.png" alt="آیکون"/>
                </div>
                {situation["page_name"] === "hooshbazi" && grades.map((item, index) => (
                    <div onClick={() => setGradeIndex(index)}
                         className={`flex flex-row text-[min(1vw,2vh)] cursor-pointer justify-end border-2 border-[#001037] font-light text-right my-[min(1vw,2vh)] hover:border-[#4044ED] items-center rounded-[min(0.5vw,1vh)] w-[80%] mx-[10%] h-[min(2.5vw,5vh)] bg-[#${(index === situation["gradeIndex"] && situation["page_name"] === "hooshbazi") ? "4044ED" : "001037"}]`}>
                        {item[1]}
                        <span
                            className={"bg-white w-[min(0.75vw,1.5vh)] h-[min(0.75vw,1.5vh)] m-[min(1vw,2vh)] rounded-sm"}></span>
                    </div>
                ))}

                <div onClick={() => setGradeIndexForDars(0)}
                     className={`flex flex-row text-[min(1.2vw,2.4vh)] cursor-pointer mt-[min(1.5vw,3vh)] justify-end border-2 border-[#001037] my-[min(1vw,2vh)] hover:border-[#4044ED] items-center rounded-[min(0.5vw,1vh)] w-[90%] mx-[5%] h-[min(3vw,6vh)] bg-[#${situation["page_name"] === "darsbazi" ? "4044ED" : "001037"}]`}>
                    درس بازی
                    <img className="h-[70%] m-[8%]"
                         src="https://uploads.zibazi.tv/site/assets/organ/states/hooshbazi.png" alt="آیکون"/>
                </div>
                {situation["page_name"] === "darsbazi" && grades.map((item, index) => (
                    <div onClick={() => setGradeIndexForDars(index)}
                         className={`flex flex-row text-[min(1vw,2vh)] cursor-pointer justify-end border-2 border-[#001037] font-light text-right my-[min(1vw,2vh)] hover:border-[#4044ED] items-center rounded-[min(0.5vw,1vh)] w-[80%] mx-[10%] h-[min(2.5vw,5vh)] bg-[#${(index === situation["gradeIndex"] && situation["page_name"] === "darsbazi") ? "4044ED" : "001037"}]`}>
                        {item[1]}
                        <span
                            className={"bg-white w-[min(0.75vw,1.5vh)] h-[min(0.75vw,1.5vh)] m-[min(1vw,2vh)] rounded-sm"}></span>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default State;
